'use client';

import { motion } from 'framer-motion';
import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { CTAButton } from '@/shadcn/ui/button';
import { PageFAQSchema } from '@/sanity/pages/PageFAQTemplate';
import heroMobileBackground from '@/public/global/hero-mobile-background.png';
import heroDesktopBackground from '@/public/global/hero_desktop_background-lg-2.png';
import Image from 'next/image';

const ease = [0.25, 0.1, 0.25, 1] as const;

export default function HeroSection({ data }: { data: PageFAQSchema }) {
  return (
    <section className="relative w-full pt-[10rem] pb-[5.5rem] lg:pt-[15rem] lg:pb-[10rem]">
      <motion.div
        initial={{ opacity: 0, filter: 'blur(8px)' }}
        animate={{ opacity: 1, filter: 'blur(0px)' }}
        transition={{ duration: 1.2, ease }}
        className="absolute w-full h-full top-[0rem] lg:hidden block z-0 pointer-events-none"
      >
        <Image
          src={heroMobileBackground}
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </motion.div>
      <motion.div
        initial={{ opacity: 0, filter: 'blur(8px)' }}
        animate={{ opacity: 1, filter: 'blur(0px)' }}
        transition={{ duration: 1.2, ease }}
        className="absolute w-full h-[130rem] top-[0rem] hidden lg:block z-0 pointer-events-none"
      >
        <Image
          src={heroDesktopBackground}
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </motion.div>
      <div className="mx-auto flex w-[min(170.5rem,calc(100%-4rem))] lg:w-[min(170.5rem,calc(100%-8rem))] flex-col items-center gap-[3.5rem] text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease }}
          className="flex flex-col items-center gap-[2.5rem]"
        >
          <div className="flex flex-col items-center gap-[1.25rem]">
            {data?.heroChip && (
              <p className="mb-0 font-blacker italic text-[2.25rem] leading-[1.5] text-black/70">
                {data.heroChip}
              </p>
            )}

            {data?.heroTitle && (
              <div className="richtext prose-headings:mb-0 prose-p:mb-0 prose-p:text-black/70 prose-p:text-[2rem] prose-p:leading-[1.5] max-w-[89rem] flex flex-col gap-[1.5rem]">
                <PortableText
                  value={data.heroTitle}
                  components={richTextComponent}
                />
              </div>
            )}
          </div>

          {data?.heroCTA && (
            <div className="w-full lg:w-fit">
              <CTAButton data={data.heroCTA} />
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
